import React, { useEffect, useState } from "react";
import axios from "axios";

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const res = await axios.get(
          "https://winkdic.com/2025/B2B/server/get_all_content_url?content_type=1"
        );

        // ✅ Extract HTML string from response
        const htmlString = res?.data || "";

        // ✅ Parse and extract only <body> content
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const bodyContent = doc.body?.innerHTML || htmlString;

        setContent(bodyContent);
      } catch (err) {
        console.error("Error fetching Privacy Policy:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-5">
        <h5>Loading Privacy Policy...</h5>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <div className="container my-5">
        <div className="bg-white rounded shadow-sm p-4 p-md-5">
          <h1
            className="mb-4 pb-3"
            style={{
              borderBottom: "3px solid #ff6b35",
              fontSize: "36px",
            }}
          >
            Privacy Policy
          </h1>

          {/* ✅ Render HTML content from admin dynamically */}
          <div
            className="text-justify"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
